<template>
  <page
    :back-to="getPreviousUrl"
    :title="$tc('wifi.detail', 2)"
    size="is-desktop"
  >
    <div slot="page-header-right">
      <button @click="destroy" class="button is-danger is-outlined mr-2">
        Delete
      </button>
      <router-link :to="`/wifi/vendors/${$route.params.id}/edit`">
        <button class="button is-primary is-outlined">
          <span>Edit</span>
        </button>
      </router-link>
    </div>

    <detail v-if="vendor.data" :vendor="vendor.data"></detail>
    <networks-table @reload="reload" v-if="network"></networks-table>
    <magazine-table @reload="reload" v-if="magazine"></magazine-table>
    <opens-table @reload="reload" v-if="opens"></opens-table>

  </page>
</template>

<script>

import Detail from "@/modules/admin/pages/wifi/components/VendorInfoTable";
import NetworksTable from "@/modules/admin/pages/wifi/components/NetworkTable";
import OpensTable from "@/modules/admin/pages/wifi/components/OpensTable";
import MagazineTable from "@/modules/admin/pages/wifi/components/MagazineTable";

export default {
  components: {
    Detail,
    NetworksTable,
    MagazineTable,
    OpensTable,
  },
  data() {
    return {
      statusOptions: [
        {label: "All", value: "all"},
        {label: "Active", value: "active"}
      ],
      vendor: new window.RemoteData(
        () => `/admin/api/wifi/vendors/${this.$route.params.id}`
      ).load(),
      network: true,
      magazine: true,
      opens: true
    };
  },
  created() {
    if (!this.$route.query.status) {
      this.ignoreOnce = true;
    }
  },

  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  },

  methods: {
    reload(value) {
      if (value === 'magazine') {
        this.magazine = false;

        this.$nextTick(() => {
          this.magazine = true;
        });
      } else {
        this.network = false;

        this.$nextTick(() => {
          this.network = true;
        });
      }
    },

    confirm(onConfirm) {
      this.$buefy.dialog.confirm({
        title: "Are you sure?",
        message:
          "You are deleting a Wifi. You cannot restore it when its deleted.",
        cancelText: "Cancel",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm,
      });
    },

    destroy() {
      this.confirm(() => {
        this.$http
          .delete(`/admin/api/wifi/vendors/${this.$route.params.id}`)
          .then((response) => {
            this.$buefy.toast.open(response.data.message);
            this.$router.push("/wifi/vendors");
          })
          .catch((error) => {
            new window.FailedResponseHandler(error).handle();
          });
      });
    },
  }
}

</script>

